import React from "react";
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";
import { useMediaQuery } from 'react-responsive';

const AboutUs = () => {
  const mediumScreens = useMediaQuery({ maxWidth: 720});

  const handleOnClick = (link) => {
    window.location.href = window.location.origin + link
  }

  const determineTopSectionScreenView = (section) => {
    if (mediumScreens) {
      return 'flex col ai-center'
    } else {
      return 'flex ai-center'
    }
  }

  const determineCardSectionScreenView = (section) => {
    if (mediumScreens) {
      return 'flex col xl-gap sa mt-60'
    } else {
      return 'flex xl-gap sa mt-60'
    }
  }

  const determineCardContainerScreenView = (section) => {
    if (mediumScreens) {
      return 'card-container-mobile'
    } else {
      return 'card-container'
    }
  }

  return(
  <>
    <PrimaryNav />
    <main>
    {/* <Breadcrumbs crumbs={breadcrumbs} /> */}
    <div className="p-10-40">
      <h1 className="patua-one-regular fs-40">About Us</h1>
      <div id="top-section" className={determineTopSectionScreenView()}>
        <div className="sm-pad left-nopad">
            <img className="maxh-mobile-lg"  src="/About_Us.jpg" alt="two people on computer" />
        </div>
        <div className="sm-pad">
          <p className="patua-one-regular fs-20">CDC’s Digital Gateway is a digital inventory of application programming interfaces (APIs) that enables both external partners and internal programs to seamlessly integrate their data with CDC’s core systems.</p>
        </div>
      </div>

      <h2 className="page-title mb--10 mt-30">What do we do</h2>
      <p>Digital Gateway catalogues CDC APIs and services under one roof to ensure they are standardized, secure, accessible, and socialized for public use.
        Whether you want to use a CDC-approved API or share an API you have built for CDC to use, Digital Gateway is your one-stop shop for exchanging safe and secure data with CDC. </p>

      <h2 className="page-title mb--10 mt-30">Why we do it</h2>
      <p>Our mission is to connect people at all levels of public health with the data they need to make decisions by providing a centralized hub, supported by real-time public health data.    </p>
      <p>Digital Gateway helps data and information flow seamlessly between different systems and organizations. We can create a more connected and efficient healthcare ecosystem together.</p>
      
      <h2 className="page-title mb--10 mt-30">Why use our APIs?</h2>
      <p>Our APIs are here for your satisfaction. They are secured, ready and reliable for your needs.</p>

      <div className={determineCardSectionScreenView()}>
        <div className={determineCardContainerScreenView()} onClick={() => handleOnClick('/help/faq')}>
          <h2 className="patua-one-regular fs-20">FAQ</h2>
          <p className="patua-one-regular-not-bold">Find answers to commonly asked questions about Digital Gateway.</p>
          <button className='usa-button w-100 btn-blue'>
            Learn More
          </button>
        </div>

        <div className={determineCardContainerScreenView()} onClick={() => handleOnClick('/support-ticket/submit-support-ticket')}>
          <h2 className="patua-one-regular fs-20">Access Support</h2>
          <p className="patua-one-regular-not-bold">Submit a support ticket by completing our support form.</p>
          <button className='usa-button w-100 btn-blue'>
            Learn More
          </button>
        </div>

        <div className={determineCardContainerScreenView()} onClick={() => handleOnClick('/help/become-provider')}>
          <h2 className="patua-one-regular fs-20">Onboard your API</h2>
          <p className="patua-one-regular-not-bold">Learn about how you can become a part of Digital Gateway.</p>
          <button className='usa-button w-100 btn-blue'>
            Learn More
          </button>
        </div>
      </div>
      </div>
    </main>
  </>
  )
}

export default AboutUs;
 